module.exports = __webpack_public_path__ + "img/bg.ebc35a62.png";